import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Promise } from './components/Promise';
import { RootCause } from './components/RootCause';
import { DietProblem } from './components/DietProblem';
import { Method4R } from './components/Method4R';
import { WhatsIncluded } from './components/WhatsIncluded';
import { ForWho } from './components/ForWho';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initPixel } from './utils/pixel';
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <main className="w-full min-h-screen overflow-x-hidden bg-cream selection:bg-terracotta/20 selection:text-terracotta-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <Promise data-id="element-3" />
      <RootCause data-id="element-4" />
      <DietProblem data-id="element-5" />
      <Method4R data-id="element-6" />
      <WhatsIncluded data-id="element-7" />
      <ForWho data-id="element-8" />
      <FAQ data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </main>;
}